import { createSlice } from "@reduxjs/toolkit";
import { getAiCampaignDetailsAPI } from "../../services/getAiCampaignDetails";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const getAiCampaignDetailsSlice = createSlice({
  name: "getAiCampaignDetails",
  initialState: data,
  reducers: {
    getAiCampaignDetailsInfo(state) {
      state.isLoading = true;
      state.error = "";
      state.message = "";
    },
    getAiCampaignDetailsInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
      state.error = "";
    },
    getAiCampaignDetailsInfoFailure(state, action) {
      state.isLoading = false;
      state.message = "";
      state.error = action.payload;
      state.data = null;
    },
    getAiCampaignDetailsInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const getAiCampaignDetailsHandler = (payload) => async (dispatch) => {
	try {
    dispatch(getAiCampaignDetailsAction.getAiCampaignDetailsInfo());
	  const response = await getAiCampaignDetailsAPI(payload);
    dispatch(getAiCampaignDetailsAction.getAiCampaignDetailsInfoSuccess(response));
  } catch (e) {
    dispatch(
      getAiCampaignDetailsAction.getAiCampaignDetailsInfoFailure(
        e?.response?.data?.message || e?.message || e
      )
    );
  }
};

export default getAiCampaignDetailsSlice.reducer;
export const getAiCampaignDetailsAction = getAiCampaignDetailsSlice.actions;
